/** @jsx jsx */
// TODO: remove eslint statement when 'css' is implemented
import { jsx } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React, { useContext, useEffect } from 'react';
import { Breadcrumb, Breadcrumbs, Button, Intent, Tag } from '@blueprintjs/core';
import { WorkspaceActionCreator } from 'hooks/useWorkspaceState';
import { WorkspaceContext } from '/views/workspace/workspaceContext';

const {updateTransientFilter} = WorkspaceActionCreator;

/**
 * Custom renderer for the actions available to change the chart settings.
 *
 * This is a Filter Provider for the ParaCord chart.
 *
 * @param chartConfiguration
 * @param actions
 * @returns {*}
 * @constructor
 */
export const TypographActions = ({actions}) => {
  const {dispatch} = useContext(WorkspaceContext);

  const onFilter = () => {
    if (actions?.selected.length) {
      dispatch(updateTransientFilter('cluster', actions.selected));
    } else {
      dispatch(updateTransientFilter('cluster', null));
    }
  };

  return (
    <React.Fragment>
      <Breadcrumbs
        items={[]}
        breadcrumbRenderer={renderFilter}
      />
      {actions?.selected?.length ?
        <Button intent={Intent.PRIMARY}
                onClick={onFilter}>
          {`Filter ${actions.selected?.length} cluster${actions.selected?.length > 1 ? 's' : ''}`}
        </Button>
        : null
      }
    </React.Fragment>
  );
};

const renderFilter = ({key, value}) => {
  return (
    <Breadcrumb>
      <Tag intent={Intent.PRIMARY}>{`${key} (${value.count})`}</Tag>
    </Breadcrumb>
  );
};

